import { Component, OnInit, Input } from '@angular/core';
import { ContextMain } from '../../_models/common/context.main';

@Component({
  selector: 'app-footer-xtraparts',
  templateUrl: './footer-xtraparts.component.html',
  styleUrls: ['./footer-xtraparts.component.scss']
})
export class FooterXtrapartsComponent implements OnInit {
  @Input() ctx: ContextMain;
  year = 2019;
  constructor() { }

  ngOnInit() {
    const now = new Date();
    this.year = now.getFullYear();
  }
}
